import { SeekPassIconVerified } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import { Box, Inline, Text, TooltipRenderer } from 'braid-design-system';

import translations from './.vocab';

export const VerifiedIdTickTooltip = ({
  verifiedName,
  profileName,
  isSignedIn,
}: {
  verifiedName?: string | null;
  profileName: string;
  isSignedIn: boolean;
}) => {
  const { t } = useTranslations(translations);
  const verifiedNameLowerCase = verifiedName?.toLowerCase() ?? '';
  const profileNameLowerCase = profileName.toLowerCase();

  let tooltipMessage = t('SIGN_IN_TO_VIEW_VERIFIED_DETAILS');
  if (isSignedIn) {
    tooltipMessage =
      verifiedName && verifiedNameLowerCase !== profileNameLowerCase
        ? t('VERIFIED_ID_NAME', { verifiedName })
        : t('VERIFIED_ID');
  }

  return (
    <Inline space="xxsmall" alignY="center">
      <TooltipRenderer
        id="tooltip"
        placement="top"
        tooltip={<Text weight="regular">{tooltipMessage}</Text>}
      >
        {({ triggerProps }) => (
          <Box aria-label="Verified Icon" {...triggerProps}>
            <SeekPassIconVerified />
          </Box>
        )}
      </TooltipRenderer>
    </Inline>
  );
};
